<template>
    <div v-if="series">
        <CardRowText
            :label="$t('notes-dayorder')"
            :text="valueToString(series.notesDayOrder)"
            :has-border-bottom="true"
        />
        <CardRowText :label="$t('notes-setup')" :text="valueToString(series.notesSetup)" :has-border-bottom="true" />
        <CardRowText
            :label="$t('notes-early-construction-internal')"
            :text="valueToString(series.notesEarlyConstructionInternal)"
            :has-border-bottom="true"
        />
        <CardRowText
            :label="$t('notes-early-construction-external')"
            :text="valueToString(series.notesEarlyConstructionExternal)"
            :has-border-bottom="true"
        />
        <CardRowText
            :label="$t('notes-construction')"
            :text="valueToString(series.notesConstruction)"
            :has-border-bottom="true"
        />
        <CardRowText
            :label="$t('notes-execution')"
            :text="valueToString(series.notesExecution)"
            :has-border-bottom="true"
        />
        <CardRowText
            :label="$t('notes-dismantling')"
            :text="valueToString(series.notesDismantling)"
            :has-border-bottom="true"
        />
        <CardRowText
            :label="$t('notes-extended-dismantling-external')"
            :text="valueToString(series.notesExtendedDismantlingExternal)"
            :has-border-bottom="true"
        />
        <CardRowText
            :label="$t('notes-extended-dismantling-internal')"
            :text="valueToString(series.notesExtendedDismantlingInternal)"
            :has-border-bottom="true"
        />
        <CardRowText
            :label="$t('notes-technical-dismantling')"
            :text="valueToString(series.notesTechnicalDismantling)"
            :has-border-bottom="true"
        />
        <CardRowText
            :label="$t('notes-dayorder-history')"
            :text="valueToString(series.notesDayOrderHistory)"
            :help-text="$t('notes-dayorder-history-help')"
            :has-border-bottom="false"
        />
    </div>
</template>
<script setup lang="ts">
import CardRowText from '@/components/Card/CardRowText.vue';
import { useEventSeries } from '@/event/composables/useEventSeries';
import { valueToString } from '@/forms/forms';
import { computed } from 'vue';

const props = defineProps<{ seriesId: string }>();

const seriesId = computed(() => props.seriesId);
const { series } = useEventSeries(seriesId);
</script>
